<template>
  <div class="pl-3 pt-3 pb-2 bg-light-fracture1 rounded-top">
    <h4 class="modal-title">ユーザを選択</h4>
  </div>
  <div class="p-3" >
    <div class="pl-4">
      <div class="d-flex">
        <div class="flex-fill">
        <div class="d-flex mt-3">

          <h4 style="width:150px;">ユーザー名</h4>
          <el-input
            placeholder="ユーザー名を入力"
            name="userName"
            autocomplete="off"
            v-model="searchCondition.userName"
            clearable 
          ></el-input>
        </div>
        <div class="d-flex mt-3">
          <h4 style="width:150px;">メールアドレス</h4>
          <el-input
            placeholder="メールアドレスを入力"
            name="email"
            autocomplete="off"
            v-model="searchCondition.email"
            clearable 
          ></el-input>
        </div>
        </div>
        
        <div class="d-flex justify-content-center mt-3 pl-3 pt-5 pb-5">
          <el-button icon="el-icon-search" @click="onClickSearch" class="pl-5 pr-5 border-primary text-primary" v-if="index != 0">{{$t("共通.23")}}</el-button>
        </div>
      </div>
      <hr class="mt-3 mb-2" />
      <h4 class="mt-3">追加するユーザーを選択</h4>
      <div class="mt-3 overflow-auto" style="max-height:300px;border-top:1px solid silver;border-bottom:1px solid silver;">
        <el-table
          v-if="userList"
          class="table-responsive align-items-center table-flush"
          header-row-class-name="thead-light app-th-row"
          highlight-current-row
          header-cell-style="font-size:1.0rem;border-bottom:2px solid #cccccc;color:black;white-space:nowrap;overflow: visible;text-overflow:clip !important;"
          ref="formItemList"
          @select="handleSelectRow"
          @select-all="handleSelectAll"
          :data="userList"
          :empty-text="$t('共通.12')"
        >
          <!-- チェックボックス -->
          <el-table-column type="selection" align="left" min-width="120px" >
          </el-table-column>

          <el-table-column
            prop="type"
            :label="ユーザー名"
          >
            <template v-slot="{ row }">
              {{row.user.name}}
            </template>
          </el-table-column>

          <el-table-column
            prop="name"
            :label="メールアドレス"
            >
            <template v-slot="{ row }">
              {{row.user.email}}
            </template>
          </el-table-column>

        </el-table>
      </div>

      
    </div>
    <div class="d-flex mt-4">
      <div class="my-box flex-fill pr-1">
        <base-button
          block
          type="secondary"
          @click="onClickModalCancel"
          >{{$t("共通.13")}}</base-button
        >
      </div>
      
      <div  class="my-box flex-fill pl-1">
        <base-button
          v-if="selectedUsers.length > 0"
          block
          type="primary"
          @click="onClickAdd"           
          >{{`${selectedUsers.length}ユーザーを${$t("共通.16")}`}}</base-button
        >
        <base-button
          v-if="selectedUsers.length == 0"
          block
          type="dark"
          disabled
          >{{$t("共通.16")}}</base-button
        >
      </div>
    </div>
    <modal v-model:show="showConfirm" v-if="showConfirm" style="z-index:1051 !important;" body-classes="p-0">
      <confirm-modal 
        :title="confirm.title"
        :message="confirm.message" 
        :leftButtonLabel="confirm.leftButtonLabel" 
        :rightButtonLabel="confirm.rightButtonLabel" 
        @onClickLeftButton="onClickConfirmLeft"
        @onClickRightButton="onClickConfirmRight"
       />
    </modal>
  </div>
</template>

<script>
import constants from "@/Config/constants";
import ValidateUtil from "@/appUtils/ValidateUtil"
import UserModel from "@/appModel/users/UserModel"
import { useToast } from "vue-toastification";
import SortUtil from "@/appUtils/SortUtil"

export default {
  components: {
    
  },
  props: {
  },
  watch: {
    
  },
  data() {
    return {
      selectedUsers: [],
      confirm: {
        tirle: "削除確認",
        message: "",
        leftButtonLabel: "キャンセル",
        rightButtonLabel: "削除",
        leftButtonFn: null,
        rightButtonFn: null
      },
      searchCondition: {
        userName: "",
        email: ""
      },
      userList: [],
      showConfirm: false,
      loader: null,
      toastId: "GeneralMemberModal"
    }
  },
  beforeCreate() {
    //インスタンスは生成されたがデータが初期化される前
  },
  created() {
    
  },
  beforeMount() {
    //インスタンスが DOM 要素にマウントされる前
    this.init().then(function(){
      console.log(``)
    })
  },
  mounted() {
    //インスタンスが DOM 要素にマウントされた後
  },
  beforeUpdate() {
    //データは更新されたが DOM に適用される前
  },
  updated() {
    //データが更新され､且つ DOM に適用された後
  },
  beforeUnmount() {
    //Vue インスタンスが破壊される前
  },
  unmounted() {
    //Vue インスタンスが破壊された後
  },
  //ボタンイベントなどのメソッドはmethodsに
  methods: {
    /**
     * 画面表示時一度だけ行う初期化処理
     */
    async init() {
      const userInfo = await this.$root.getUserInfo()
      this.tenantId = userInfo.group
      this.showLoader()
      await this.search()
      this.hideLoader()
    },
    /**
     * ユーザ検索ボタン押下
     */
    async onClickSearch() {
      await this.search()
    },
    /**
     * 条件に従いユーザ検索
     */
    async search() {
      // テナント内ユーザをすべて取得
      // テナント毎のユーザ数は上限があるため検索はクライアントサイドのフィルタで行う
      let userList = await UserModel.getUserList(this.tenantId)
      this.userList = await SortUtil.sort(userList, "user.name", "ascending", true);
      // 条件に従い配列をフィルタリング
      if (!this.searchCondition.userName && !this.searchCondition.email) {
        return
      }
      this.userList = this.userList.filter(function(item){
        // 該当有無のフラグ(true:該当あり false:該当なし)
        let flg = false
        let userFlg = true
        let emailFlg = true
        try {
          if (this.searchCondition.userName){
            if (item.user.name) {
              userFlg = item.user.name.indexOf(this.searchCondition.userName) >= 0
            } else {
              userFlg = false
            }
          }

          if (this.searchCondition.email){
            if (item.user.email) {
              emailFlg = item.user.email.indexOf(this.searchCondition.email) >= 0
            } else {
              emailFlg = false
            }
          }
          return userFlg && emailFlg
        } catch (e) {
          console.log(JSON.stringify(e))
        }
        return true

      }.bind(this))
    },
    /**
     * ユーザー一覧の選択時
     */
    handleSelectRow(selection, row){
      this.selectedUsers = selection
      
    },
    /**
     * ユーザー一覧の全選択時
     */
    handleSelectAll(selection) {
      this.handleSelectRow(selection, null)
    },
    /**
     * 処理中インジケーターを表示します。
     * @returns 表示したインジケーター
     */
    showLoader() {
      this.loader = this.$loading.show({
        container: null,
        canCancel: false,
        color: "#E4007F",
        width: 64,
        height: 64,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        isFullPage: true,
        zIndex: 9999,
      })
    },
    /**
     * 処理中インジケーターを閉じます。
     * @paramas {Object} loader 表示したインジケーター
     */
    hideLoader() {
      this.loader.hide();
    },
    /**
     * キャンセルボタン押下時
     */
    onClickModalCancel() {
      
      this.$emit("onCancel");
    },
    /**
     * 追加ボタン押下時
     */
    onClickAdd() {
      this.hideToast()
      
      this.$emit("onAdd", this.selectedUsers);
      
    },
    /**
     * 確認ダイアログの左側ボタン押下時
     */
    onClickConfirmLeft() {
      this.confirm.leftButtonFn()
    },
    /**
     * 確認ダイアログの右側ボタン押下時
     */
    onClickConfirmRight() {
      this.confirm.rightButtonFn()
    },
    // ----------------
    // トースト
    // ----------------
    /**
     * トースト表示
     */
    runToast(message, type) {
      const pos = 'bottom-center'
      const toast = useToast();
      toast[type](message, {
        hideProgressBar: true,
        icon: false,
        toastClassName: ["custome-toast-class"],
        closeButton: false,
        position: pos,
        id: this.toastId
      });
    },
    /**
     * トースト非表示
     */
    hideToast() {
      const toast = useToast();
      toast.dismiss(this.toastId)
    }
  }
}
</script>